import config from '@/config'
import api from '@/api'
let o = {}
/*
* public static final String TARGET_TYPE_DEPT = "01";
public static final String TARGET_TYPE_POST = "02";
public static final String TARGET_TYPE_STAFF = "03";
public static final String TARGET_TYPE_GROUP = "04";
public static final String TARGET_TYPE_USER = "05";
public static final String TARGET_TYPE_ROLE = "06";
public static final String TARGET_TYPE_TAG = "07";
* */
var _fromBack = function (url, id, type, publicState) {
  return new Promise((resolve, reject) => {
    api.post(config.bylApiPath, url, {itemId: id, itemType: type}, function (r) { // 正常
      var publicStateList = []
      if (r.data) {
        if (publicState == '2') {
          publicStateList = []
        } else {
          publicStateList = r.data
        }
        // console.log(publicStateList)
        for (let i = 0; i < publicStateList.length; i++) {
          let o = publicStateList[i]
          o.name = o.targetName
          o.id = o.targetId
          if (o.targetType == '01') {
            o.uitype = '01'
          } else if (o.targetType == '03') {
            o.uitype = '02'
          } else if (o.targetType == '05') {
            o.uitype = '03'
          } else if (o.targetType == '07') {
            o.uitype = '04'
            o.tagType = '06'
          }
        }
      }
      resolve(publicStateList)
    })
  })
}
o.setRangePermissions = function (obj, isAll) {
  var submitted = {
    itemId: obj.itemId,
    itemType: obj.itemType,
    permission: obj.permission
  }
  var r = []
  if (isAll) {
    r.push({
      targetId: '9999-9999',
      targetName: '全员',
      targetType: '01'
    })
  } else {
    for (let i = 0; i < obj.permissionList.length; i++) {
      let o = obj.permissionList[i]
      let ro = {};
      ro.targetId = o.id
      ro.targetName = o.name
      if (o.uitype == '01') {
        ro.targetType = '01'
      } else if (o.uitype == '02') {
        ro.targetType = '03'
      } else if (o.uitype == '03') {
        ro.targetType = '05'
      } else if (o.tagType) {
        ro.targetType = '07'
      }
      r.push(ro)
    }
  }
  submitted.studyItemPermissionList = r
  return submitted
}
o.saveRange = function (o, callback) {
  api.post(config.bylApiPath, '/studyItemPermissions/save', o, (r) => { // 正常
    if (callback) {
      callback()
    }
  })
}
o.saveScope = function (o, callback) {
  api.post(config.bylApiPath, '/studyItemScopes/save', o, (r) => { // 正常
    if (callback) {
      callback()
    }
  })
}
o.saveTo = function (id, type, publicState, scope, callback) { // id: 设置的itemId, type: 设置的资源类型, publiState: 设置的分配范围, scope: 设置的可见范围
  var self = this
  if (publicState) {
    var rangeParams = {
      itemId: id,
      itemType: type,
      permission: '02'
    }
    if (publicState.type == '0') {
      rangeParams.permissionList = ''
    } else {
      rangeParams.permissionList = publicState.value
    }
    // console.log(self.setRangePermissions(rangeParams))
    if (publicState.type == '1' || publicState.type == '0') { // 调用后台保存分配范围
      self.saveRange(self.setRangePermissions(rangeParams), callback)
    } else if (publicState.type == '2') {
      self.saveRange(self.setRangePermissions(rangeParams, true), callback)
    }
  }
  if (scope) {
    var scopeParams = {
      itemId: id,
      itemType: type,
      permission: '02'
    }
    if (scope.type == '0') {
      scopeParams.permissionList = ''
    } else {
      scopeParams.permissionList = scope.value
    }
    if (scope.type == '1' || scope.type == '0') { // 调用后台保存可见范围
      self.saveScope(self.setRangePermissions(scopeParams), callback)
    } else if (scope.type == '2') {
      self.saveScope(self.setRangePermissions(scopeParams, true), callback)
    }
  }
}
o.getRange = function (id, type, publicState) {
  return _fromBack('/studyItemPermissions/scope', id, type, publicState)
}
o.getScope = function (id, type, publicState) {
  return _fromBack('/studyItemScopes/scope', id, type, publicState)
}
o.getPersonTypes = function(arr) {
  let o = {}
  o.tags = arr.filter((o) => {
    return o.tagType
  }).length
  o.members = arr.filter((o) => {
    return o.uitype == '02'
  }).length
  o.users = arr.filter((o) => {
    return o.uitype == '03'
  }).length
  o.depts = arr.filter((o) => {
    return o.uitype == '01'
  }).length
  return o
}
o.checkScope = function (o) {
  return new Promise((resolve, reject) => {
    api.post(config.bylApiPath, '/studyItemScopes/checkPermission', o, (r) => { // 正常
      resolve(r)
    })
  })
}
export default o



// WEBPACK FOOTER //
// ./src/utils/rangePermission.js